export enum RepairTypeId {
  BluetoothPairingIssue = 58,
  CardReader = 72,
  Cleaning = 63,
  Controller = 71,
  CrackedScreen = 3,
  DataRecoveryBackup = 66,
  DataTransfer = 65,
  DriverUpdate = 68,
  FactoryReset = 64,
  GraphicsCardUpgrade = 70,
  HDMIPort = 73,
  IDontKnow = 6,
  Keyboard = 69,
  SoftwareInstall = 67,
  WifiBluetoothIssues = 74,
}
